// src/components/common/SkeletonCard.jsx
import React from 'react'

export default function SkeletonCard() {
    return (
        <div className="animate-pulse bg-white rounded-lg shadow-sm border p-6">
            <div className="h-48 bg-black-200 rounded-lg mb-4"></div>
            <div className="space-y-3">
                <div className="h-4 bg-black-200 rounded w-3/4"></div>
                <div className="h-4 bg-black-200 rounded w-1/2"></div>
                <div className="h-4 bg-black-200 rounded w-5/6"></div>
            </div>
        </div>
    )
}